/** Caixas de entrada: os números de WhatsApp da loja (a principal primeiro). */
import type { CaixaEntrada } from "@ydchat/shared";
import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

export function useCaixas() {
  return useQuery({
    queryKey: ["caixas"],
    queryFn: () => api.get<CaixaEntrada[]>("/caixas"),
    staleTime: 5 * 60_000,
  });
}

/** Só faz sentido mostrar de qual caixa veio a conversa quando há mais de uma. */
export function useVariasCaixas() {
  return (useCaixas().data?.length ?? 0) > 1;
}
